/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import { RequestStatus } from "../../data/constants";
import { saveCourseSettingsScheduleAndDetails } from "./api";
import { CoPresent } from "@openedx/paragon/icons";

const slice = createSlice({
  name: "scheduleAndDetails",
  initialState: {
    loadingDetailsStatus: RequestStatus.IN_PROGRESS,
    loadingSettingsStatus: RequestStatus.IN_PROGRESS,
    savingStatus: "",
    courseDetails: {},
    courseSettings: {},
    courseConfig: {},
  },
  reducers: {
    updateLoadingDetailsStatus: (state, { payload }) => {
      state.loadingDetailsStatus = payload.status;
    },
    updateLoadingSettingsStatus: (state, { payload }) => {
      state.loadingSettingsStatus = payload.status;
    },
    updateSavingStatus: (state, { payload }) => {
      state.savingStatus = payload.status;
    },
    updateCourseDetailsSuccess: (state, { payload }) => {
      Object.assign(state.courseDetails, payload);
    },
    fetchCourseDetailsSuccess: (state, { payload }) => {
      Object.assign(state.courseDetails, payload);
    },
    fetchCourseSettingsSuccess: (state, { payload }) => {
      Object.assign(state.courseSettings, payload);
    },
    saveCourseSettingsScheduleAndDetailsSuccess: (state, { payload }) => {
      console.log(payload, state);
      Object.assign(state.courseSettings, payload);
    },
    getCourseConfigSuccess: (state, { payload }) => {
      Object.assign(state.courseConfig, payload);
    },
  },
});

export const {
  updateSavingStatus,
  updateLoadingDetailsStatus,
  updateLoadingSettingsStatus,
  updateCourseDetailsSuccess,
  fetchCourseDetailsSuccess,
  fetchCourseSettingsSuccess,
  saveCourseSettingsScheduleAndDetailsSuccess,
  getCourseConfigSuccess,
} = slice.actions;

export const { reducer } = slice;
